import { DOCUMENT, Injectable, inject } from '@angular/core';

import { Observable, fromEvent } from 'rxjs';

import { SliderContainerDirective } from './slider-container.directive';

@Injectable({ providedIn: 'root' })
export class SliderEventService {
    private container = inject(SliderContainerDirective, { optional: true });

    private readonly _doc = inject(DOCUMENT);

    get mousemove(): Observable<MouseEvent> {
        const container = this.container?.element.nativeElement || this._doc;

        return fromEvent<MouseEvent>(container, 'mousemove');
    }

    get mouseup(): Observable<MouseEvent> {
        return fromEvent<MouseEvent>(this._doc, 'mouseup');
    }
}
